"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const propNames = ['id', 'value', 'onChange', 'label', 'optional', 'validationError', 'themeControlSwitchContainer', 'themeControlSwitch', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

class ControlSwitch extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", e => {
      return this.props.onChange(e.target.checked, this.props.id);
    });
  }

  render() {
    const extraProps = (0, _omit.default)(this.props, propNames);
    const {
      id,
      value,
      label,
      validationError,
      themeControlSwitchContainer,
      themeControlSwitch,
      themeControlWrapper,
      optional,
      themeLabel
    } = this.props; // value might be an empty string. Form will do this if no initialValue
    // is set.

    const checked = value === '' ? false : value;
    const inputProps = {
      id,
      checked,
      onChange: this.onChange,
      type: 'checkbox',
      'data-test': `${id}-input`
    };

    if (validationError) {
      inputProps['aria-invalid'] = true;
    }

    return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
      themeControlWrapper: themeControlWrapper,
      id: id,
      validationError: validationError
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: `switch-container ${themeControlSwitchContainer}`
    }, /*#__PURE__*/_react.default.createElement("input", _extends({}, inputProps, extraProps)), /*#__PURE__*/_react.default.createElement("div", {
      className: `switch ${themeControlSwitch}`
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: themeLabel
    }, label, optional && /*#__PURE__*/_react.default.createElement("span", {
      className: "ml3 txt-normal"
    }, "(optional)"))));
  }

}

exports.default = ControlSwitch;

_defineProperty(ControlSwitch, "propTypes", {
  /** Identifying value for input element. */
  id: _propTypes.default.string.isRequired,

  /** Input value */
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf([''])]),

  /** If provided the text, "(optional)" is appended to the value of the label element. */
  optional: _propTypes.default.bool,

  /** Called during changes to the input element. */
  onChange: _propTypes.default.func.isRequired,

  /** Value passed to the label element. */
  label: _propTypes.default.node,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /** Assembly classes to apply to the switch container */
  themeControlSwitchContainer: _propTypes.default.string,

  /** Assembly classes to apply to the switch element */
  themeControlSwitch: _propTypes.default.string,

  /** Assembly classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** Assembly classes to apply to the label element */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlSwitch, "defaultProps", {
  value: false,
  themeControlSwitchContainer: '',
  themeControlSwitch: 'switch--s-label',
  optional: false,
  themeLabel: 'txt-s ml6'
});